
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
directives: {
TransferDom
},
components: {
Group,
CellBox,
Tab,
TabItem,
Flexbox,
FlexboxItem,
XButton,
Scroller,
LoadMore,
XDialog
},
data() {
return {
courselist: [],
img: [],
img1: [],
nowIndex: 0, //默认第一个tab为激活状态
tabSelected: 'B',
idCode: 'B',
levelID: '1',
nowIndex1: -1,
nowIndex2: -1,
bottomCount: 1,
onFetching: false,
resourceURL:"",
returnUrl:""
}
},
methods: {
CutName:function(name){
if(name.length>15){
return name.substring(0,14)+"..";
}
},

JumpVideo: function (url, IDCode) {
this.$router.push({
path: url,
name: url,
params: {
IDCode: IDCode,
level1: this.$route.params.level1,
level2: this.$route.params.level2,
level3: this.$route.params.level3,
}
})
},
jump: function (e) {
this.$router.push(e);
},

jumpCourse: function (index) {
this.$router.push({
path: "/Class/Course",
name: "/Class/Course",
params: {
index: index,
tabSelected: this.tabSelected,
idCode: this.idCode,
levelID: this.levelID,
nowIndex1: this.nowIndex1,
nowIndex2: this.nowIndex2
}
});
},
},
mounted() {
this.resourceURL = this.$tyh.RESOURCEURL;

document.getElementById("CourseList").style.height = window.innerHeight * 0.7 +'px';

this.tabSelected = this.$route.params.tabSelected;
this.idCode = this.$route.params.idCode;
this.levelID = this.$route.params.levelID;
this.nowIndex1 = this.$route.params.nowIndex1;
this.nowIndex2 = this.$route.params.nowIndex2;
this.$tyh.CourseByGroup(this.$route.params.cougroupIDCode, "All", 1, 99999)
.then((data) => {

var show_data = new Array();
for (var t in data.data.Data.course) {
var time = this.$tyh.formatSeconds(data.data.Data.course[t].PlayTime);
var name = data.data.Data.course[t].Name;

var showdatas = {
IDCode: data.data.Data.course[t].IDCode,
ResCount: data.data.Data.course[t].ResCount,
Logo: data.data.Data.course[t].Logo,
Content: data.data.Data.course[t].Content,
ViewCount: data.data.Data.course[t].ViewCount,
Name: name,
PlayTime: time
}
show_data.push(showdatas)
}
this.courselist = show_data;
});
},
}



// WEBPACK FOOTER //
// ./src/views/Index/CourseList.vue